import './App.css';
import NavBar from './components/navbar';
// import Signup from './components/signup';
// import Login from './components/login';
// import React, { useState, useEffect } from 'react';
// import { Button, Form } from 'react-bootstrap';

function App() {
	return (
		<div className="App">
			<NavBar />
			{/* {screen} */}
		</div>
	);
}
export default App;
